<template>
	<el-form ref="form" :model="form" label-width="106px" class="form" :rules="rules">
		<el-form-item label="企业类型" prop="typeid">
			<el-select v-model="form.typeid" placeholder="请选择企业类型">
				<el-option-group v-for="item in industryList" :key="item.id" :label="item.title">
					<el-option v-for="items in item.child" :key="items.id" :label="items.title" :value="items.id" />
				</el-option-group>
			</el-select>
		</el-form-item>
		<el-form-item label="主营行业" prop="hangyeid">
			<el-select v-model="form.hangyeid" placeholder="请选择主营行业">
				<el-option v-for="item in infoList" :key="item.id" :label="item.catname" :value="item.id" />
			</el-select>
		</el-form-item>
		<el-form-item v-for="(item,index) in form.zycp" :key="index" :label="'主营产品'+(index+1)" prop="zycp">
			<el-input class="small-input" v-model="form.zycp[index]" />
			<el-button v-if="index!=0" @click="delZycp(index)">删除</el-button>
		</el-form-item>
		<el-form-item>
			<el-button @click="addZycp">新增主营产品</el-button>
		</el-form-item>
		<el-form-item label="经营地址" prop="xian">
			<area-select v-model="addressData" type="text" :data="pcaa" :level="2" @change="handleAddressChange" />
		</el-form-item>
		<el-form-item label="详细地址" prop="address">
			<el-input v-model="form.address" />
		</el-form-item>
		<el-form-item>
			<el-button type="primary" @click="onSubmit">下一步</el-button>
			<div class="tsci">
				<el-checkbox v-model="checked"></el-checkbox>我已经阅读并同意<a href="" title="入会协议声明">《入会协会声明》</a>
			</div>
		</el-form-item>
	</el-form>
</template>

<script>
	import {
		pca,
		pcaa
	} from 'area-data'
	import 'vue-area-linkage/dist/index.css'
	import Axios from 'axios'
	export default {
		data() {
			return {
				form: {
					typeid: '',
					hangyeid: '',
					zycp: [''],
					sheng: '',
					shi: '',
					xian: '',
					address: ''
				},
				industryList: [],
				infoList: [],
				pca,
				pcaa,
				addressData: [],
				checked:false,
				rules: {
					typeid: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.typeid === '') {
								callback(new Error('请选择企业类型'));
							} else {
								callback();
							}
						}
					}],
					hangyeid: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.hangyeid === '') {
								callback(new Error('请选择主营行业'));
							} else {
								callback();
							}
						}
					}],
					zycp:[{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.zycp == '') {
								callback(new Error('请选择主营产品'));
							} else {
								callback();
							}
						}
					}],
					xian: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.xian === '') {
								callback(new Error('请选择经营地址'));
							} else {
								callback();
							}
						}
					}],
					address: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.address === '') {
								callback(new Error('请填写详细地址'));
							} else {
								callback();
							}
						}
					}]
				}
			}
		},
		created() {
			this.$axios.post('/Myseller-setting-getshop').then(data => {
				this.form = data
				if(data){
					let ade = []
					ade.push(data.sheng)
					ade.push(data.shi)
					ade.push(data.xian)
					this.addressData = ade
				}
			})
			this.$axios.post('Myseller-Setting-getindustry', {
				user_id: this.$store.state.USER_ID
			}).then(data => {
				this.industryList = data.industry
				this.infoList = data.info
			})
		},
		methods: {
			addZycp() {
				this.form.zycp.push('')
			},
			delZycp(index) {
				this.form.zycp.splice(index, 1)
			},
			handleAddressChange(data) {
				this.form.sheng = data[0]
				this.form.shi = data[1]
				this.form.xian = data[2]
				this.addressData = data
			},
			onSubmit(data) {
				if(this.checked){
					Object.assign(this.form, data)
					this.$refs.form.validate((valid) => {
						if (valid) {
							this.$emit('eventNext', this.form)
						} else {
							return false;
						}
					})
				}else{
					this.$alert('需同意 入会协会声明 可进行下一步', '提示', {
						 type: 'error',
						 confirmButtonText: '确定',
					});
				}
				
			}
		}
	}
</script>

<style scoped>
	.small-input {
		width: 300px;
		margin-right: 10px;
	}

	.form>>>.area-select {
		height: 40px;
		line-height: 26px;
		margin-left: 0;
		margin-bottom: 10px;
	}
	el-checkbox{
		margin-right: 10px;
	}
	.tsci{
		font-size:12px;
		color:#333;
		
	}
	.tsci a{
		color:#08c;
	}
</style>
